import { fireAnalytics } from '../firebase.js'
import { getDeviceCategory, getSessionId } from '../analyticsHelpers.ts'
import type { SelectedMaterial } from '../../types/calculadoraDeMateriales.ts'

export const ESTIMATION_LIST_PRICES_READY_EVENT = 'estimation_list_prices_ready'

export function countEstimationPricedLines(materials: SelectedMaterial[]): {
  lineCount: number
  pricedLineCount: number
  totalEstimated: number
} {
  let pricedLineCount = 0
  let totalEstimated = 0
  for (const m of materials) {
    const price = m.price != null ? Number(m.price) : NaN
    const qty = Number(m.quantity) || 0
    if (Number.isFinite(price) && price >= 0 && qty > 0) {
      pricedLineCount += 1
      totalEstimated += price * qty
    }
  }
  return { lineCount: materials.length, pricedLineCount, totalEstimated }
}

export function trackEstimationListPricesReady(args: {
  edifyUserId: string
  lineCount: number
  pricedLineCount: number
  totalEstimated: number
  fileName?: string
  draftId?: string
}): void {
  fireAnalytics(ESTIMATION_LIST_PRICES_READY_EVENT, {
    category: 'estimation',
    action: ESTIMATION_LIST_PRICES_READY_EVENT,
    edify_user_id: args.edifyUserId || '',
    session_id: getSessionId(),
    device_category: getDeviceCategory(),
    line_count: args.lineCount,
    priced_line_count: args.pricedLineCount,
    total_estimated: args.totalEstimated,
    ...(args.fileName ? { file_name: args.fileName } : {}),
    ...(args.draftId ? { draft_id: args.draftId } : {}),
  })
}
